import BasicMatchingSub from './BasicMatchingSub.page';

export default BasicMatchingSub;
